export default __webpack_public_path__ + "static/media/Picture1.f06c03d5.png";